<template>
    <div>
        <notifications
            :duration="1500"
            :ignoreDuplicates="true"
            :max="2"
            classes="toast-style"
            position="bottom center"
        />
        <notifications
            :duration="1500"
            :ignoreDuplicates="true"
            :max="2"
            classes="toast-style"
            group="Story"
            position="top center"
        />
        <notifications
            :duration="8000"
            :ignoreDuplicates="true"
            classes="toast-style border border-gray-100 rounded-md shadow-md"
            group="Adyen"
            position="top center"
        />
        <notifications
            :duration="1000"
            :ignoreDuplicates="true"
            classes="toast-style"
            group="BillPay"
            position="top center"
        />
        <notifications
            :duration="1000"
            :ignoreDuplicates="true"
            :width="320"
            classes="offline-toast shadow-md"
            group="offline"
            position="top center"
        />
        <notifications
            :duration="5000"
            :ignoreDuplicates="true"
            classes="toast-style shadow-md"
            group="PiggyRewards"
            position="top center"
        />
    </div>
</template>

<script>
export default {
    name: 'notification-groups'
};
</script>
